import styled from "styled-components";
import { blue } from "../../../styles/variables.style";

export const ContactFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .ant-input-group .ant-row {
    width: 50%;
  }

  .ant-btn {
    margin-top: 30px;
    width: 400px;
    background: ${blue};
  }

  .ant-form {
    width: 100%;
    .ant-form-item {
      margin: 0px;
      .ant-form-item-control-input-content {
        display: flex;
        justify-content: center;
      }
    }
  }

  @media (max-width: 1024px) {
    .ant-input-group {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 300px;
    }

    .ant-btn {
      width: 95%;
    }
  }
`;
